export default __webpack_public_path__ + "static/media/sqr_img_4.e8c7773f.svg";